import { DateBox } from "devextreme-react";
import { RequiredRule } from "devextreme-react/form";
import React, { useRef, useState } from "react";

export default function TwoDateBoxComponent2(props) {
  const { firstDateBox, secondDateBox, formDataSource } = props;

  const onFirstValueChanged = (e) => {
    if (secondDateBox.ref.current) {
      secondDateBox.ref.current.instance.option("min", e.value);
    }
  };

  return (
    <React.Fragment>
      <DateBox
        ref={firstDateBox.ref}
        placeholder={firstDateBox.placeholder}
        style={{
          float: "left",
          width: "49%",
          marginRight: "3px",
        }}
        displayFormat="yyyy-MM-dd"
        dateSerializationFormat="yyyy-MM-dd"
        showClearButton={true}
        // onValueChanged={onFirstValueChanged}
        defaultValue={
          formDataSource ? formDataSource[firstDateBox.field] : null
        }
        onValueChanged={onFirstValueChanged}
      >
        {firstDateBox.requiredRuleMessage && (
          <RequiredRule message={firstDateBox.requiredRuleMessage} />
        )}
      </DateBox>
      <DateBox
        ref={secondDateBox.ref}
        placeholder={secondDateBox.placeholder}
        style={{
          float: "left",
          width: "49%",
          marginRight: "2px",
        }}
        displayFormat="yyyy-MM-dd"
        dateSerializationFormat="yyyy-MM-dd"
        showClearButton={true}
        defaultValue={
          formDataSource ? formDataSource[secondDateBox.field] : null
        }
        // min={
        //   firstDateBox.ref.current
        //     ? firstDateBox.ref.current.instance.option("value")
        //     : null
        // }
      />
    </React.Fragment>
  );
}
